import React from "react";

const CarToefl = ({ datos }) => {
  const { valor, estructura } = datos;

  return (
    <tr>
      <td><b>{estructura}</b></td>
      <td className="text-right">{valor}</td>
    </tr>
  );
};

export default CarToefl;
